import React,{useEffect} from "react";
// Sections
import TopNavbar from "../components/Nav/TopNavbar";
//import Header from "../components/Sections/Header";
//import Blog from "../components/Sections/Blog";
//import Pricing from "../components/Sections/Pricing";
import Contact from "../components/Sections/Contact"
import Footer from "../components/Sections/Footer"
import FAQs from "../components/Sections/FAQs"
import Home from "./Home";
import ProductsAndServices from "./ProductsAndServices";
import Solutions from "./Solutions";
import FoundersStory from "../components/Sections/FoundersStory";
import HowItWorks from "../components/Sections/HowItWorks";
import FinancialInclusionSection from "../components/Sections/FinancialInclusion";
import FeaturesSection from "../components/Sections/Features";
import AboutMastaKash from "../components/Sections/AboutMastakash";
import FoundersSection from "../components/Sections/FoundersSection";
import FAQsSection from "../components/Sections/FAQs";
import InvestorPitchPage from "./pitch";
import MastaKashFundraising from "./FundraisingLandingPage";



export default function Landing() {
  useEffect(() => {
    const sections = document.querySelectorAll('.section');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
        }
      });
    });

    sections.forEach(section => {
      observer.observe(section);
    });

    return () => {
      // Cleanup the observer when the component unmounts
      observer.disconnect();
    };
  }, []); // Empty dependency array ensures the effect runs only once after the component mounts

  return (
    <>
      <TopNavbar />
      <br/><br/><br/>
      <Home className="section animated-section"/>
       <HowItWorks className="section animated-section"/>
       <br/><br/>
       <FinancialInclusionSection className="section animated-section"/> 
      <ProductsAndServices className="section animated-section"/> 
      <FeaturesSection className="section animated-section"/>
      <FAQsSection className="section animated-section"/>
       <AboutMastaKash className="section animated-section"/>     
      {/*<InvestorPitchPage className="section animated-section"/>*/}
      <br/><br/>
        <MastaKashFundraising className="section animated-section"/>
        <br/>

      {/*<FoundersSection className="section animated-section"/>*/}
      <Contact className="section animated-section"/>   
       

      <Footer />
    </>
  );
}


